import { GtoAnalytics } from './gtoAnalytics.js';

if (typeof window !== 'undefined') {
    new GtoAnalytics();
}
